// UNCOMMENT IF DRUPAL - see components/_meta/_01-foot.twig for attachBehaviors
// Drupal.behaviors.accordion = {
//   attach: function (context, settings) {

(function () { // REMOVE IF DRUPAL

  jQuery(document).ready(function() {

    // wait until all external assets are loaded (css stylesheets, js scripts, fonts, images, etc)
    jQuery(window).bind("load", function() {

      'use strict';
      var UID = {
        _current: 0,
        getNew: function(){
          this._current++;
          return this._current;
        }
      };

      String.prototype.hashCode = function() {
        var hash = 0, i, chr;
        if (this.length === 0) return hash;
        for (i = 0; i < this.length; i++) {
          chr   = this.charCodeAt(i);
          hash  = ((hash << 5) - hash) + chr;
          hash |= 0; // Convert to 32bit integer
        }
        return hash;
      };

      HTMLElement.prototype.setPseudoStyle = function(element,prop,value, hash){
        var _this = this;
        var _sheetId = "pseudoStyles";
        var _head = document.head || document.getElementsByTagName('head')[0];
        var _sheet = document.getElementById(_sheetId) || document.createElement('style');
        _sheet.id = _sheetId;
        var className = "pseudoStyle" + UID.getNew();
        if(hash){
          className = "pseudoStyle" + hash;
        }

        if(_this.className.indexOf(className) === -1) {
          _this.className +=  " "+className;
        }
        var pattern = new RegExp("\." + className + ":" + element + "\{\\S*\}", "g");

        _sheet.innerHTML = _sheet.innerHTML.replace(pattern, '');

        _sheet.innerHTML += " ."+className+":"+element+"{"+prop+":"+value+"}";
        _head.appendChild(_sheet);
        return this;
      };

      var connect_ctas = document.querySelectorAll('.tile--bg-connect');
      var news_ctas = document.querySelectorAll('.grid--bg-news');
      var share_ctas = document.querySelectorAll('.tile--bg-share');

      var smController = new ScrollMagic.Controller();

      Array.prototype.forEach.call(news_ctas, function (ele, index){

        let key = index.toString();
        let dur = ele.getBoundingClientRect().height;
        let eleContents = ele.querySelector('.card__container');
        let contentSel = ele.className.replace(/\s/g, '.') + ' .card__container';
        let hash = contentSel + '--' + key;
        hash = hash.hashCode();
        contentSel = '.' + contentSel;
        let pseudoSel = contentSel + ':after';


        //let initialPos = parseFloat(window.getComputedStyle(eleContents, ':after').getPropertyValue('left'));
        let initialPos = window.getComputedStyle(eleContents, ':after').getPropertyValue('transform');
        initialPos = initialPos.replace('matrix(', '').replace(')', '').replace(/\s/g, '');
        //Fifth item in matrix is translateX
        initialPos = parseFloat(initialPos.split(',')[4]);
        var progress = 0;



        let scene = new ScrollMagic.Scene({ triggerElement: ele, duration: document.body.getBoundingClientRect().height, offset: -dur * 0.15})
          .addTo(smController)
          .on("progress", function(evt) {
            progress = evt.progress;

          })
          .on("update", function (evt){
            let eleContents = ele.querySelector('.card__container');
            //let curPos = parseFloat(window.getComputedStyle(eleContents, ':after').getPropertyValue('left'));
            let curPos = window.getComputedStyle(eleContents, ':after').getPropertyValue('transform');
            curPos = curPos.replace('matrix(', '').replace(')', '').replace(/\s/g, '');
            //Fifth item in matrix is translateX
            curPos = parseFloat(curPos.split(',')[4]);

            let increment = (progress * 10) ? (progress * 10) : 1;

            if(progress > 0) {
              let leftMar = parseFloat(window.getComputedStyle(eleContents, ':after').getPropertyValue('margin-left'));

              if(evt.target.controller().info("scrollDirection") == "REVERSE"){

                if((leftMar - 25) < 0 || evt.scrollPos < evt.scrollStart){
                  eleContents.setPseudoStyle('after', 'margin-left', 0 + 'px', hash);
                } else {
                  eleContents.setPseudoStyle('after', 'margin-left', (leftMar - 15) + 'px', hash);
                }

                //let rule = CSSRulePlugin.getRule('.grid--bg-connect .card__container::after, .grid--bg-connect .tile__container::after, .tile--bg-connect .card__container::after, .tile--bg-connect .tile__container::after');
                //console.log(rule);
              } else {
                if(!window.getComputedStyle(eleContents, ':after').getPropertyValue('margin-left')){
                  eleContents.setPseudoStyle('after', 'margin-left', (leftMar + 15) + 'px', hash);
                } else {
                  eleContents.setPseudoStyle('after', 'margin-left', (leftMar + 15) + 'px', hash);
                }

                // let rule = CSSRulePlugin.getRule('.grid--bg-connect .card__container::after, .grid--bg-connect .tile__container::after, .tile--bg-connect .card__container::after, .tile--bg-connect .tile__container::after');
                // console.log(rule)
              }

            } else {
              eleContents.setPseudoStyle('after', 'margin-left', 0 + 'px', hash);
            }

          })
      });

      Array.prototype.forEach.call(share_ctas, function (ele, index){

        let key = index.toString();
        let dur = ele.getBoundingClientRect().height;
        let eleContents = ele.querySelector('.tile__container');
        let contentSel = ele.className.replace(/\s/g, '.') + ' .tile__container';
        let hash = contentSel + '--' + key;
        hash = hash.hashCode();
        contentSel = '.' + contentSel;
        let pseudoSel = contentSel + ':after';


        //let initialPos = parseFloat(window.getComputedStyle(eleContents, ':after').getPropertyValue('left'));
        let initialPos = window.getComputedStyle(eleContents, ':after').getPropertyValue('transform');
        initialPos = initialPos.replace('matrix(', '').replace(')', '').replace(/\s/g, '');
        //Fifth item in matrix is translateX
        initialPos = parseFloat(initialPos.split(',')[4]);
        var progress = 0;

        let scene = new ScrollMagic.Scene({ triggerElement: ele, duration: document.body.getBoundingClientRect().height, offset: -dur * 0.15})
          .addTo(smController)
          .on("progress", function(evt) {
            progress = evt.progress;
          })
          .on("update", function (evt){
            let eleContents = ele.querySelector('.tile__container');
            //let curPos = parseFloat(window.getComputedStyle(eleContents, ':after').getPropertyValue('left'));
            let curPos = window.getComputedStyle(eleContents, ':after').getPropertyValue('transform');
            curPos = curPos.replace('matrix(', '').replace(')', '').replace(/\s/g, '');
            //Fifth item in matrix is translateX
            curPos = parseFloat(curPos.split(',')[4]);

            let increment = (progress * 10) ? (progress * 10) : 1;

            if(progress > 0) {
              let leftMar = parseFloat(window.getComputedStyle(eleContents, ':after').getPropertyValue('margin-left'));

              if(evt.target.controller().info("scrollDirection") == "REVERSE"){
                if((leftMar - 25) < 0 || evt.scrollPos < evt.scrollStart){
                  eleContents.setPseudoStyle('after', 'margin-left', 0 + 'px', hash);
                } else {
                  eleContents.setPseudoStyle('after', 'margin-left', (leftMar - 15) + 'px', hash);
                }
              } else {
                if(!window.getComputedStyle(eleContents, ':after').getPropertyValue('margin-left')){
                  eleContents.setPseudoStyle('after', 'margin-left', (leftMar + 15) + 'px', hash);
                } else {
                  eleContents.setPseudoStyle('after', 'margin-left', (leftMar + 15) + 'px', hash);
                }

                // let rule = CSSRulePlugin.getRule('.grid--bg-connect .card__container::after, .grid--bg-connect .tile__container::after, .tile--bg-connect .card__container::after, .tile--bg-connect .tile__container::after');
                // console.log(rule)
              }

            }

          })
      });

      Array.prototype.forEach.call(connect_ctas, function (ele, index){

        let key = index.toString();
        let dur = ele.getBoundingClientRect().height;
        let eleContents = ele.querySelector('.tile__container');
        let contentSel = ele.className.replace(/\s/g, '.') + ' .tile__container';
        let hash = contentSel + '--' + key;
        hash = hash.hashCode();
        contentSel = '.' + contentSel;
        let pseudoSel = contentSel + ':after';


        //let initialPos = parseFloat(window.getComputedStyle(eleContents, ':after').getPropertyValue('left'));
        let initialPos = window.getComputedStyle(eleContents, ':after').getPropertyValue('transform');
        initialPos = initialPos.replace('matrix(', '').replace(')', '').replace(/\s/g, '');
        //Fifth item in matrix is translateX
        initialPos = parseFloat(initialPos.split(',')[4]);
        var progress = 0;

        let scene = new ScrollMagic.Scene({ triggerElement: ele, duration: dur})
          .addTo(smController)
          .on("progress", function(evt) {
            progress = evt.progress;
          })
          .on("update", function (evt){
            let eleContents = ele.querySelector('.tile__container');
            //let curPos = parseFloat(window.getComputedStyle(eleContents, ':after').getPropertyValue('left'));
            let curPos = window.getComputedStyle(eleContents, ':after').getPropertyValue('transform');
            curPos = curPos.replace('matrix(', '').replace(')', '').replace(/\s/g, '');
            //Fifth item in matrix is translateX
            curPos = parseFloat(curPos.split(',')[4]);

            let increment = (progress * 10) ? (progress * 10) : 1;

            if(progress > 0) {
              let leftMar = parseFloat(window.getComputedStyle(eleContents, ':after').getPropertyValue('margin-left'));

              if(evt.target.controller().info("scrollDirection") == "REVERSE"){
                if((leftMar - 25) < 0 || evt.scrollPos < evt.scrollStart){
                  eleContents.setPseudoStyle('after', 'margin-left', 0 + 'px', hash);
                } else {
                  eleContents.setPseudoStyle('after', 'margin-left', (leftMar - 15) + 'px', hash);
                }                //let rule = CSSRulePlugin.getRule('.grid--bg-connect .card__container::after, .grid--bg-connect .tile__container::after, .tile--bg-connect .card__container::after, .tile--bg-connect .tile__container::after');
                //console.log(rule);
              } else {
                if(!window.getComputedStyle(eleContents, ':after').getPropertyValue('margin-left')){
                  eleContents.setPseudoStyle('after', 'margin-left', (leftMar + 15) + 'px', hash);
                } else {
                  eleContents.setPseudoStyle('after', 'margin-left', (leftMar + 15) + 'px', hash);
                }

                // let rule = CSSRulePlugin.getRule('.grid--bg-connect .card__container::after, .grid--bg-connect .tile__container::after, .tile--bg-connect .card__container::after, .tile--bg-connect .tile__container::after');
                // console.log(rule)
              }

            }

          })
      });



      // Set 'document' to 'context' if Drupal

    });

  });



})(); // REMOVE IF DRUPAL

// UNCOMMENT IF DRUPAL
//   }
// };
